<template>
  <div class="apresentacoes-view">
    <v-row>
      <v-col class="maincol">
        <Card title="Convites" color="green">
          <div>
            <div v-if="convites.length > 0">
              <ItemApresentacao v-for="convite in convites" v-bind:key="convite.codigo" v-bind:apr="convite"></ItemApresentacao>
            </div>
            <div v-if="convites.length === 0" class="nenhum-convite">Não há convites pendentes</div>
          </div>
        </Card>
        <Card title="Apresentações Futuras" color="blue">
          <div>
            <div v-if="futuras.length > 0">
              <ItemApresentacao v-for="ftr in futuras" v-bind:key="ftr.codigo" v-bind:apr="ftr"></ItemApresentacao>
            </div>
            <div v-if="futuras.length === 0" class="nenhum-convite">Não há apresentações marcadas</div>
          </div>
        </Card>
        <!-- <v-btn color="blue">+ Adicionar Apresentação</v-btn> !-->
        <v-divider class="divider"/>
        <Card title="Apresentações Passadas">
          <div>
            <div v-if="passadas.length > 0">
              <ItemApresentacao v-for="psd in passadas" v-bind:key="psd.codigo" v-bind:apr="psd"></ItemApresentacao>
            </div>
            <div v-if="passadas.length === 0" class="nenhum-convite">Não há apresentações passadas? Ué, algo deu errado...</div>
          </div>
        </Card>
      </v-col>
    </v-row>
    <v-btn fab dark large color="primary" fixed right bottom v-on:click.native="adicionar">
          <v-icon dark>mdi-music-note-plus</v-icon>
        </v-btn>
  </div>
</template>

<script>
// @ is an alias to /src
import ItemApresentacao from '@/components/ItemApresentacao.vue'

function compararData (a, b) {
  if (!a.data || !b.data || new Date(a.data.seconds * 1000) < new Date(b.data.seconds * 1000)) return 1
  if (new Date(a.data.seconds * 1000) > new Date(b.data.seconds * 1000)) return -1
  return 0
}

export default {
  name: 'apresentacoes',
  components: {
    ItemApresentacao
  },
  data () {
    return {
      apresentacoes: []
    }
  },
  methods: {
    adicionar: function (event) {
      this.$router.push({ name: 'Adicionar Apresentação' })
    }
  },
  computed: {
    convites: function () {
      const convites = []
      for (let i = 0; i < this.$store.state.apresentacoes.length; i++) {
        const apr = this.$store.state.apresentacoes[i]
        if (apr && !apr.confirmada && !apr.recusada) {
          convites.push(apr)
        }
      }
      return convites.sort(compararData)
    },
    futuras: function () {
      const futuras = []
      for (let i = 0; i < this.$store.state.apresentacoes.length; i++) {
        const apr = this.$store.state.apresentacoes[i]
        if (apr && apr.confirmada && !apr.recusada && apr.data.seconds * 1000 > Date.now()) {
          futuras.push(apr)
        }
      }
      return futuras.sort(compararData)
    },
    passadas: function () {
      const passadas = []
      for (let i = 0; i < this.$store.state.apresentacoes.length; i++) {
        const apr = this.$store.state.apresentacoes[i]
        if (apr && apr.confirmada && !apr.recusada && apr.data.seconds * 1000 < Date.now()) {
          passadas.push(apr)
        }
      }
      return passadas.sort(compararData)
    },
    listaapresentacoes: function () {
      const apresentacoes = []
      for (let i = 0; i < this.$store.state.apresentacoes.length; i++) {
        const apr = this.$store.state.apresentacoes[i]
        if (apr && apr.confirmada && !apr.recusada) {
          apresentacoes.push(apr)
        }
      }
      return apresentacoes.sort(compararData)
    }
  },
  mounted () {
    if (!this.$store.state.apresentacoes.length) {
      console.log('Bound Apresentações')
      this.$store.dispatch('bindApresentacoes')
    }
  },
  created () {
    document.title = 'Apresentações | Acappolli Hub'
    document.head.querySelector('meta[name=description]').content = 'Apresentações Acappolli'
  }
}
</script>

<style scoped>
h1 {
  font-size: 2rem;
  margin-top: 5px;
}
.main-wrapper {
  margin: auto;
  margin-top: 20px;
  padding-top: 10px;
  padding: 16px;
  color: black;
  background-color: #FFFFFF;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.buttonholder {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.addbutton {
  margin: auto;
}

.addbutton::v-deep {
  width: fit-content;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 1em;
  height: 2em;
}

.convite-item {
  color: white;
  padding: 10px;
  margin-top: 10px;
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
  border-radius:6px;
  -moz-border-radius:6px;
  -webkit-border-radius:6px;
}

.nenhum-convite {
  text-align: center;
  color: gray;
  margin-top: 20px;
  margin-bottom: 20px;
}

.divider {
  margin-top: 50px;
  margin-bottom: 70px;
}

.maincol {
  margin: auto;
  max-width: 800px;
}

  /* Mobile Styles */
@media only screen and (max-width: 415px) {
    .main-wrapper {
        width: 100%;
        margin-top: 0px;
    }
}

/* iphone XR */
@media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
    .main-wrapper {
        width: 100%;
        margin-top: 0px;
    }
}

/* Desktop Styles */
@media only screen and (min-width: 416px) {
  .maincol {
    margin: auto;
    max-width: 800px;
  }
}
</style>
